import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { FiPlus, FiSearch, FiDownload, FiMoreHorizontal } from "react-icons/fi";
import { FormGroup, FormControl, Dropdown } from "react-bootstrap";
import Loading from "components/Loading";
import Layout from "components/Layout";
// import CompanySubscriptionsList from "components/Companies/CompanySubscriptionsList";
import CompanyPartnersList from "components/Companies/CompanyPartnersList";
import RegisterCompanyModal from "components/Companies/RegisterCompanyModal";
import { showModal, hideModal, updateModalLoading } from "actions/modalActions";
import * as companyActions from "actions/companyActions";
import Modal from "components/Modal";
import { companyService, appService } from "services";

class Subscriptions extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // searchSubscription: "",
            searchCompany: "",
        };

        // console.log(props);
        this.closeModal = this.closeModal.bind(this);
    }

    async componentDidMount() {
        const companyId = this.props.user.company.id;
        // console.log(companyId);
        await this.props.getCompany(companyId);
        this.props.getSubscriptionTypes();
        // this.getSubscriptions();
        // console.log(this.props.company);
        // console.log(this.props.partner_companies);
        this.setState({
            company: this.props.company,
            partner_companies: this.sortByName(this.props.company.partner_companies || []),
        });
    }

    sortByName = (companies) =>
        [...companies].sort((a, b) =>
            (a.name || "").localeCompare(b.name || "", "es", { sensitivity: "base" })
        );

    handleChangeSearch = (event) => {
        this.setState(
            {
                [event.target.id]: event.target.value,
            },
            () => {
                // this.getSubscriptions();
                this.getCompanies();
            }
        );
    };

    // async getSubscriptions() {
    // 	const companyId = this.props.user?.company?.id;
    // 	await this.props.getAllSubscriptions(companyId);
    // }

    async getCompanies() {
        const { searchCompany } = this.state;

        // Fuente de datos original (sin filtrar)
        const allPartnerCompanies =
            (this.props.company && this.props.company.partner_companies) || [];

        // Si no hay texto en el buscador, mostramos todas
        if (!searchCompany || !searchCompany.trim()) {
            this.setState({
                partner_companies: this.sortByName(allPartnerCompanies),
            });
            return;
        }

        const term = searchCompany.trim().toLowerCase();

        const filtered = allPartnerCompanies.filter((company) => {
            const name = (company.name || "").toLowerCase();
            const email = (company.email || "").toLowerCase();

            return name.includes(term) || email.includes(term);
        });

        this.setState({
            partner_companies: this.sortByName(filtered),
        });
    }

    closeModal() {
        this.props.hideModal();
    }

    async refreshCompanies() {
        const companyId = this.props.user.company.id;
        await this.props.getCompany(companyId);
        this.setState({
            company: this.props.company,
            partner_companies: this.sortByName(this.props.company.partner_companies || []),
        });
    }

    async handleExportPartners() {
        const { searchCompany } = this.state;
        const { t } = this.props;
        const response = await companyService.exportPartners({ q: searchCompany || undefined });

        if (response.ok) {
            this.openExportPartnersModal(response.access_token);
        } else {
            this.openAlertModal(t("common.error"), t("subscriptionsPage.exportError"));
        }
    }

    openExportPartnersModal(token) {
        const { t } = this.props;
        this.props.showModal(
            {
                open: true,
                title: t("subscriptionsPage.exportModal.title"),
                style: { width: "400px" },
                confirmText: t("common.download"),
                loadingText: t("subscriptionsPage.exportModal.downloading"),
                message: t("subscriptionsPage.exportModal.message"),
                closeModal: this.closeModal,
                confirmAction: () => {
                    this.props.updateModalLoading(true);
                    this.downloadExport(token, "empresas-gestionadas.xlsx");
                },
            },
            "confirm"
        );
    }

    async downloadExport(token, filename) {
        const response = await appService.getExported(token);
        const url = window.URL.createObjectURL(response);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.href = url;
        a.download = filename;
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.props.updateModalLoading(false);
        this.closeModal();
    }

    openAlertModal(title, message) {
        this.props.showModal(
            {
                open: true,
                title,
                style: { width: "400px" },
                message,
                closeModal: this.closeModal,
            },
            "alert"
        );
    }

    openNewCompanyModal() {
        const { t } = this.props;
        this.props.showModal(
            {
                open: true,
                title: t("subscriptionsPage.registerCompany"),
                style: { width: "500px" },
                content: (
                    <RegisterCompanyModal
                        handleClose={this.closeModal}
                        onSuccess={() => this.refreshCompanies()}
                    />
                ),
                closeModal: this.closeModal,
            },
            "edit"
        );
    }

    getContent = () => {
        if (this.props.loading) {
            return <Loading />;
        }

        if (!this.state.partner_companies) {
            return this.props.t("subscriptionsPage.loadError");
        }
        return (
            <CompanyPartnersList
                    partner_companies={this.state.partner_companies}
                    onCompanyUpdated={() => this.refreshCompanies()}
                />
        );
        // return (
        // 	<CompanySubscriptionsList
        // 		company_subscriptions={this.props.company_subscriptions}
        // 	/>
        // );
    };

    render() {
        return (
            <>
                <Layout className="page-subscriptions" context="subscriptions">
                    <div className="heading">
                        <h1 className="title">{this.props.t("subscriptionsPage.title")}</h1>

                        <div className="heading-filters">
                            <FormGroup
                                className="form-group form-search"
                                controlId="searchCompany"
                            >
                                <FormControl
                                    type="text"
                                    placeholder={this.props.t("subscriptionsPage.filter")}
                                    value={this.state.searchCompany}
                                    onChange={this.handleChangeSearch}
                                />
                                <FiSearch />
                            </FormGroup>
                        </div>
                        <div className="heading-actions">
                            <button
                                type="button"
                                title={this.props.t("subscriptionsPage.exportToExcel")}
                                onClick={() => this.handleExportPartners()}
                                className="btn btn-export"
                            >
                                <FiDownload />
                            </button>
                            <button
                                type="button"
                                title={this.props.t("subscriptionsPage.registerCompany")}
                                onClick={() => this.openNewCompanyModal()}
                                className="btn btn-new"
                            >
                                <FiPlus />
                            </button>
                        </div>
                    </div>

                    {this.getContent()}
                </Layout>

                <Modal hideModal={this.props.hideModal} />
            </>
        );
    }
}

const mapStateToProps = (reducers) => {
    const r = {
        ...reducers.companyReducer,
        user: reducers.authReducer.user,
    };
    return r;
};

const mapDispatchToProps = (dispatch) => ({
    hideModal: () => dispatch(hideModal()),
    showModal: (modalProps, modalType) => {
        dispatch(showModal({ modalProps, modalType }));
    },
    updateModalLoading: (isLoading) => dispatch(updateModalLoading(isLoading)),
    getCompany: (company_id) => dispatch(companyActions.getCompany(company_id)),
    getAllSubscriptions: (company_id) =>
        dispatch(companyActions.getAllSubscriptions(company_id)),
    getSubscriptionTypes: () => dispatch(companyActions.getSubscriptionTypes()),
});

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Subscriptions));